'use client';
import { useEffect } from 'react';

export default function ServiceWorkerRegistrar() {
    useEffect(() => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker
                .register('/sw.js')
                .then((registration) => {
                    console.log('[PWA] Service Worker registrado:', registration.scope);
                })
                .catch((error) => {
                    console.error('[PWA] Error al registrar Service Worker:', error);
                });
        }
    }, []);

    return null;
}
